/**
 * `taskDeck` namespace (ADR 0133) — the read-only run/task deck.
 */
export const messages = {
  button: 'Run deck',
  openTitle: 'Run deck',
  heading: 'Run deck',
  blurb: 'Your runs and the work delegated from them — pending, running, blocked, delegated, completed, and failed.',
  empty: 'No runs yet. Runs you start (and the work they delegate) appear here.',
  close: 'Close',
  bucket_pending: 'Pending',
  bucket_running: 'Running',
  bucket_blocked: 'Blocked',
  bucket_delegated: 'Delegated',
  bucket_completed: 'Completed',
  bucket_failed: 'Failed',
  delegatedBy: 'Delegated by {{by}}',
  loadFailed: 'Couldn’t load the run deck.',
  refresh: 'Refresh',
  refreshing: 'Refreshing…',
  refreshFailed: 'Couldn’t refresh. Showing the last loaded deck.',
  truncated: 'Only your most recent activity is shown. Older runs may be missing.',
  showingOf: 'Showing {{shown}} of {{count}}',
  wait_approval: 'Waiting for an approval',
  wait_clarification: 'Waiting for an answer',
  'wait_external-event': 'Waiting for an outside event',
  wait_timer: 'Waiting for a scheduled time',
  wait_credential: 'Waiting for a connection',
  wait_other: 'Waiting',
  updated: 'Updated {{when}}',
  openConversation: 'Open conversation',
  openInbox: 'See what needs you',
  openRun: 'Open run',
  delegatedFrom: 'Work delegated from {{title}}',
  cancelled: 'Cancelled',
};
